import {isNotNil} from 'ramda';

import {GetDataByDataQueryApiResponse} from '@dms/api/core';

import {KANBAN_COLUMN_VALUE_TO_INDEX} from '../constants/kanbanColumns';
import {Card} from '../types/Card';
import {mapBusinessCasesToCards} from './mapBusinessCasesToCards';
import {mapInterestsToCards} from './mapInterestsToCards';

/**
 * Gets cards for a specific column by column value (string)
 * This function uses automatically generated mapping to ensure consistency
 */
export const getCardsForColumnValue = (
  columnValue: string,
  businessCases?: GetDataByDataQueryApiResponse,
  interests?: GetDataByDataQueryApiResponse
): Card[] => {
  const allCards: Card[] = [];

  if (isNotNil(businessCases)) {
    const businessCaseCards = mapBusinessCasesToCards(businessCases);
    allCards.push(...businessCaseCards);
  }

  if (isNotNil(interests)) {
    const interestCards = mapInterestsToCards(interests);
    allCards.push(...interestCards);
  }

  const targetColumnIndex = KANBAN_COLUMN_VALUE_TO_INDEX[columnValue];

  if (targetColumnIndex === undefined) {
    throw new Error(
      `Unknown columnValue: "${columnValue}". Check KANBAN_COLUMN_VALUE_TO_INDEX mapping.`
    );
  }

  return allCards.filter((card) => card.column === targetColumnIndex);
};
